import React, {useMemo} from 'react';
import {useTranslation} from "react-i18next";
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {Dropdown, Layout, MenuProps} from "antd";
import "./template.css";
import ArrowDown from "../../assets/svgs/ArrowDown";
import {EMenu} from "../screens/tracking/type";
import {useShippingInfo} from "../../api/useShippingInfo";

export const MenuTemplate = () => {
    let {tracking} = useParams();
    let {pathname} = useLocation();
    const navigate = useNavigate()
    const {t} = useTranslation("tracking");
    const {shipping} = useShippingInfo(tracking)
    let opt = EMenu.search;
    if (pathname.includes(EMenu.reqReturn)) {
        opt = EMenu.reqReturn;
    } else if (pathname.includes(EMenu.return)) {
        opt = EMenu.return;
    } else if (pathname.includes(EMenu.info)) {
        opt = EMenu.info;
    } else if (pathname.includes(EMenu.entrance)) {
        opt = EMenu.entrance;
    } else if (pathname.includes(EMenu.exchange)) {
        opt = EMenu.exchange;
    } else if (tracking) {
        opt = EMenu.tracking;
    }
    const items: MenuProps['items'] = useMemo(() => {
        const items = [
            {
                label: t('search.title'),
                key: EMenu.search,
            },
            {
                label: t('tracking.title'),
                key: EMenu.tracking,
            },
            {
                label: t('info.title'),
                key: EMenu.info,
            },
            {
                label: t('entrance.title'),
                key: EMenu.entrance,
            }];
        if (!shipping?.tracking_number_return &&
            shipping?.show_return_button_tracking_app &&
            !shipping?.is_return &&
            shipping?.status !== 'CREATED' &&
            shipping?.status !== 'READYFORPICKUP')
            items.push({
                label: t('Request return'),
                key: EMenu.reqReturn,
            })
        if (shipping?.is_exchange)
            items.push({
                label: t('exchange.title'),
                key: EMenu.exchange,
            })
        if (shipping?.is_return)
            items.push({
                label: t('return.title'),
                key: EMenu.return
            })
        return items;
    }, [shipping]);

    const handleChangeOption = ({key}: any) => {
        if (key === EMenu.tracking) {
            navigate(`/tracking/${tracking}`)
        } else if (key === EMenu.search) {
            navigate('/')
        } else {
            navigate(`/tracking/${tracking}/${key}`)
        }
    }

    return (<Layout className={"inner"}>
        <Dropdown
            menu={{
                items,
                onClick: handleChangeOption,
            }}
            align={{offset: [0, 0]}}
            placement={'bottom'}
            trigger={['click']}
        >
            <div className={'option-cntr row space-between'}>
                <span
                    onMouseEnter={e => e.preventDefault()}
                    className={'primary body bold'}
                    data-cy={'dropDown'}
                >
                    {t(opt + '.title')}
                </span>
                <ArrowDown color={'#00000045'} rotate={0}/>
            </div>
        </Dropdown>
        <Outlet/>
    </Layout>);
};
